type AsyncTrack = (
  eventName: string,
  props: { [key: string]: string | number | boolean },
) => Promise<boolean>;

export const track: AsyncTrack = async (...args) => {
  const Smartlook = await getSmartlook();

  if (Smartlook.initialized()) {
    return Smartlook.track(...args);
  }

  return false;
};

export const getSmartlook = async () => {
  const { default: Smartlook } = await import("smartlook-client");
  return Smartlook;
};
